import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { Modal, Typography, Box } from "@mui/material";
import * as S from "./styles";
import { useCreateData, useGetTableData2 } from "../Plan/tableHooks";
import { useParams } from "react-router-dom";
import {
  ModuleRegistry,
  AllCommunityModule,
  themeQuartz,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import styled from "styled-components";
import DownloadIcon from "@mui/icons-material/Download";
import { CustomButton, CancelButton } from "../../common/Buttons";
import { AG_GRID_LOCALE_KR } from "@ag-grid-community/locale";

ModuleRegistry.registerModules([AllCommunityModule]);
const ModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65%;
  background-color: var(--mui-palette-background-paper);
  box-shadow: var(--mui-shadows-8);
  padding: 24px;
  border-radius: 12px;
`;
const GridContainer = styled.div`
  width: 100%;
  height: 600px;
  display: flex;
  gap: 1.5rem;
  flex: 1;
  overflow: hidden;
  padding: 0 16px 16px;
  .ag-theme-material,
  .ag-theme-quartz {
    --ag-material-primary-color: var(--mui-palette-primary-main);
    --ag-background-color: var(--mui-palette-background-paper);
    --ag-odd-row-background-color: var(--mui-palette-action-hover);
    --ag-header-background-color: var(--mui-palette-background-default);
    --ag-border-color: var(--mui-palette-divider);
    --ag-row-hover-color: var(--mui-palette-action-hover);
    border-radius: 4px;
    overflow: hidden;
    height: 100%;
    .ag-cell-inline-editing {
      height: 100% !important;
      overflow: hidden !important;
      padding: 0 !important;
    }
    .ag-cell-edit-input {
      height: 100% !important;
      width: 100% !important;
      padding: 0 10px !important;
      box-sizing: border-box !important;
      margin: 0 !important;
      border: none !important;
    }
    .ag-cell {
      display: flex;
      align-items: center;
    }
    .ag-row {
      height: 48px !important;
    }
    .ag-header-cell {
      font-weight: 600;
    }
  }

  .inner-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;
const rightColDef = [
  {
    field: "machine_id",
    headerName: "머신ID",
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
    flex: 1,
  },
  {
    field: "machine_name",
    headerName: "장비명",
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
    flex: 2,
  },
];
const leftColDef = [
  {
    field: "machine_id",
    headerName: "머신ID",
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
    flex: 1,
  },
  {
    field: "machine_name",
    headerName: "장비명",
    headerClass: "grid-header",
    cellStyle: { textAlign: "center" },
    flex: 2,
  },
];

function MchSync({ open, onClose, setUpdateStatus, openSnackbar }) {
  const rightGridRef = useRef();
  const leftGridRef = useRef();
  const [rightSelectedRows, setRightSelectedRows] = useState([]);
  const [leftGridData, setLeftGridData] = useState([]);
  const { group_code, project_code } = useParams();
  const { masterData } = useGetTableData2(
    true,
    `/api/mch/getMaster?group_code=${group_code}&project_code=${project_code}`,
    "masterData"
  );
  const { localData } = useGetTableData2(
    true,
    `/api/mch/getLocalMachine?group_code=${group_code}&project_code=${project_code}`,
    "localData"
  );
  useEffect(() => {
    const editLocalData = localData.map((item) => {
      if (
        item.aps_machine_name &&
        item.aps_machine_name !== item.machine_name
      ) {
        return {
          ...item,
          machine_name: `${item.aps_machine_name} (${item.machine_name})`,
        };
      } else {
        return item;
      }
    });
    setLeftGridData(editLocalData);
  }, [localData]);
  const refreshLeftGrid = () => {
    if (leftGridRef.current && leftGridRef.current.api) {
      leftGridRef.current.api.setRowData(localData);
    }
  };
  useEffect(() => {
    if (leftGridRef.current && leftGridRef.current.api && localData) {
      leftGridRef.current.api.setRowData(localData);
    }
  }, [localData]);
  const createMutation = useCreateData(
    null,
    "/api/mch/postSyncMch",
    openSnackbar
  );
  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      resizable: true,
      suppressAutoSize: false,
      wrapText: false,
      filter: true,
    };
  }, []);
  const rowRightSelection = useMemo(() => {
    return {
      mode: "multiRow",
    };
  }, []);
  const onRightSelectionChanged = () => {
    const selectedNodes = rightGridRef.current.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setRightSelectedRows(selectedData);
  };
  //   const onClickBatchUpdate = async () => {
  //     try {
  //       const res = await axios.get(
  //         APS_URL +
  //           `/api/mch/getBatchMchUpdate?group_code=${group_code}&project_code=${project_code}`
  //       );
  //       // batch update 아직 사양이 결정 안됨
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   };
  const onClickMchUpdate = async () => {
    try {
      const mchIdArray = rightSelectedRows.map((i) => i.machine_id);
      const obj = {
        group_code,
        project_code,
        data: mchIdArray,
      };
      createMutation.mutate(obj, {
        onSuccess: () => {
          rightGridRef.current.api.deselectAll();
          setRightSelectedRows([]);
          setUpdateStatus((prev) => !prev);
          setTimeout(() => {
            if (leftGridRef.current && leftGridRef.current.api) {
              leftGridRef.current.api.setRowData(localData);
            }
          }, 100);
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
  const getLeftRowStyle = useCallback(
    (params) => {
      const [matchedContents] = masterData.filter(
        (item) => item.machine_id === params.data.machine_id
      );
      const [matchedLocalContents] = localData.filter(
        (item) => item.machine_id === params.data.machine_id
      );
      if (
        matchedLocalContents?.machine_name !== matchedContents?.machine_name
      ) {
        return {
          color: "#ff5252",
          fontStyle: "italic",
          fontWeight: "600",
        };
      }
    },
    [masterData, localData]
  );
  const customGermanLocale = {
    ...AG_GRID_LOCALE_KR,
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContainer>
        <S.ModalTitle>장비 정보 동기화</S.ModalTitle>
        <GridContainer>
          <div className="inner-col">
            <Typography variant="h5" sx={{ paddingBottom: "8px" }}>
              장비 목록
            </Typography>
            <div style={{ flex: 1, overflow: "hidden" }}>
              <AgGridReact
                rowData={leftGridData}
                //  ref={leftGridRef}
                columnDefs={leftColDef}
                //    rowSelection={rowLeftSelection}
                getRowId={(params) => String(params.data.machine_id)}
                //    onRowClicked={onLeftGridClick}
                localeText={customGermanLocale}
                theme={themeQuartz}
                rowStyle={{
                  fontWeight: "500",
                  fontsize: "14px",
                }}
                defaultColDef={defaultColDef}
                rowHeight={48}
                suppressScrollOnNewData={true}
                getRowStyle={getLeftRowStyle}
                pagination={true}
              />
            </div>
          </div>
          <div className="inner-col">
            <Typography variant="h5" sx={{ paddingBottom: "8px" }}>
              장비 Master
            </Typography>
            <div style={{ flex: 1, overflow: "hidden" }}>
              <AgGridReact
                theme={themeQuartz}
                rowData={masterData}
                ref={rightGridRef}
                columnDefs={rightColDef}
                rowStyle={{
                  zIndex: 5,
                  fontWeight: "500",
                  fontsize: "14px",
                }}
                onSelectionChanged={onRightSelectionChanged}
                localeText={customGermanLocale}
                rowSelection={rowRightSelection}
                //    overlayNoRowsTemplate={noRowsOverlayComponent}
                //   onCellEditingStopped={onChangeRightQty}
                //   getRowStyle={getRightRowStyle}
                defaultColDef={defaultColDef}
                rowHeight={48}
                stopEditingWhenCellsLoseFocus={true}
                suppressMovableColumns={true}
                suppressScrollOnNewData={true}
                pagination={true}
              />
            </div>
          </div>
        </GridContainer>
        <S.ButtonGroup>
          {/* <Button
            variant="contained"
            color="success"
            sx={{ borderRadius: "8px" }}
            onClick={onClickBatchUpdate}
          >
            전체 동기화
          </Button> */}
          <CustomButton
            variant="contained"
            onClick={onClickMchUpdate}
            disabled={!rightSelectedRows.length}
            sx={{ borderRadius: "8px" }}
            startIcon={<DownloadIcon />}
          >
            가져오기
          </CustomButton>
          <CancelButton
            color="error"
            onClick={onClose}
            sx={{ borderRadius: "8px" }}
          >
            취소
          </CancelButton>
        </S.ButtonGroup>
      </ModalContainer>
    </Modal>
  );
}

export default MchSync;
